
define('ldsh!modules/templates/templates/templates_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a href="javascript:void(0)" class="ed-temp-prev js-image">\n  <p class="ed-temp-prev-text">\n    <span class="ri-eye-line"></span>\n    <span>Preview</span>\n  </p>\n  <img src="' +
((__t = ( previewUrl )) == null ? '' : __t) +
'" alt="Template 1234" title="">\n  <p class="ed-temp-name">' +
__e( name ) +
'</p>\n  <p class="ed-temp-desc">' +
__e( description ) +
'</p>\n</a>\n<a class="ed-btn ed-btn-ico ed-select-temp js-select" data-i18n="common.selectButton"></a>\n';

}
return __p
};});

